class Wishlist {
  constructor() {
    this.maxLength = 48;

    if (window.loggedIn) {
      this.readWishlist()
      .then((data) => {
        window.wishlist = data;

        if (localStorage.getItem('wishlist')) {
          this.saveLocalStorageWishlist();
        } else {
          this.wishlistLoaded();
        }
      })
    } else {
      this.getWishlistProducts();
    }

    document.addEventListener('wishlist:add', (event) => {
      this.addToWishlist(event.detail);
    });

    document.addEventListener('wishlist:remove', (event) => {
      this.removeFromWishlist(event.detail);
    });
  }

  static loggedIn() {
    return window.customerLoggedIn
  }

  static setElementLoadingState(element) {
    element.classList.add('wishlist-button--loading');
  }

  static setElementLoadingDoneState(element) {
    element.classList.remove('wishlist-button--loading');
  }

  static setElementAddedState(element) {
    element.classList.add('wishlist-button--added');
    element.setAttribute('data-wishlist-added', 'true');
  }

  static setElementRemovedState(element) {
    element.classList.remove('wishlist-button--added');
    element.removeAttribute('data-wishlist-added');
  }

  writeWishlist(data) {
    return new Promise((resolve) => {
      const body = JSON.parse(JSON.stringify(data));

      delete body.status;

      fetch(`https://${window.wishlistStrings.storeUrl}/apps/wishlist-app/wishlist`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(body)
      })
      .then(response => response.json())
      .then((data) => {
        resolve(data.wishlist);
      })
      .catch((error) => {
        if (error) resolve(error);
      })
    });
  }

  readWishlist() {
    return new Promise((resolve) => {
      fetch(`https://${window.wishlistStrings.storeUrl}/apps/wishlist-app/wishlist`)
      .then(response => response.json())
      .then((data) => {
        resolve(data.wishlist);
      })
      .catch((error) => {
        if (error) resolve(error);
      })
    })
  }

  addToWishlist({element, id, handle, title}) {
    this.clearAlert();
    Wishlist.setElementLoadingState(element);

    if (!Wishlist.productInWishlist(id)) {
      if (window.wishlist.products.length >= this.maxLength) {
        this.error(element, window.wishlistStrings.errors.max);
        return;
      }

      window.wishlist.products.push({id, handle});

      if (window.loggedIn) {
        try {
          this.writeWishlist(wishlist)
          .then(() => {
            this.addToWishlistSuccess(element, title);
          })
          .catch((error) => {
            this.error(element, window.wishlistStrings.errors.adding);
            if (error) console.error(error);
          })
        } catch (error) {
          this.error(element, window.wishlistStrings.errors.adding);
          if (error) console.error(error);
        }
      } else {
        localStorage.setItem('wishlist', JSON.stringify(window.wishlist.products));
        this.addToWishlistSuccess(element, title);
      }
    }
  }

  addToWishlistSuccess(element, title) {
    if (loggedIn) {
      this.klaviyoTracking(element, 'Added to wishlist');
    }

    this.showAlert('Success', window.wishlistStrings.added.replace('[product]', title));
    Wishlist.setElementAddedState(element);
    Wishlist.setElementLoadingDoneState(element);
    this.getWishlistProducts();
  }

  removeFromWishlist({element, id, title}) {
    this.clearAlert();
    Wishlist.setElementLoadingState(element);

    if (Wishlist.productInWishlist(id)) {
      const indexToRemove = window.wishlist.products.findIndex(product => product.id === id);

      window.wishlist.products.splice(indexToRemove, 1);

      if (window.loggedIn) {
        try {
          this.writeWishlist(wishlist)
          .then(() => {
            this.removeFromWishlistSuccess(element, title);
          })
          .catch((error) => {
            this.error(element, window.wishlistStrings.errors.removing);
            if (error) console.error(error);
          })
        } catch(error) {
          this.error(element, window.wishlistStrings.errors.removing);
          if (error) console.error(error);
        }
      } else {
        localStorage.setItem('wishlist', JSON.stringify(window.wishlist.products));
        this.removeFromWishlistSuccess(element, title);
      }
    }
  }

  removeFromWishlistSuccess(element, title) {
    if (loggedIn) {
      this.klaviyoTracking(element, 'Removed from wishlist');
    }

    this.showAlert('Success', window.wishlistStrings.removed.replace('[product]', title));
    Wishlist.setElementRemovedState(element);
    Wishlist.setElementLoadingDoneState(element);
    this.getWishlistProducts();
  }

  klaviyoTracking(element, event) {
    if (!element || !klaviyo) return;
    
    const wishlistProductDataObject = element.querySelector('.js-wishlist-product-data');

    if (wishlistProductDataObject) {
      const wishlistProductData = JSON.parse(JSON.stringify(wishlistProductDataObject.innerText));
      klaviyo.push(["track", event, wishlistProductData]);
    }
  }

  error(element, message = window.wishlistStrings.errors.default) {
    this.showAlert('Error', message);
    if (element) Wishlist.setElementLoadingDoneState(element);
  }

  clearAlert() {
    document.dispatchEvent(new Event('alert:clear'));
  }

  showAlert(status, message) {
    document.dispatchEvent(new CustomEvent('alert:show', {
      detail: {
        data: {
          status,
          message
        }
      }
    }));
  }

  getWishlistProducts() {
    if (window.loggedIn) {
      try {
        this.readWishlist()
        .then((data) => {
          window.wishlist = data;
          this.wishlistLoaded();
        })
        .catch((error) => {
          this.error(null, window.wishlistStrings.errors.loading);
          if (error) console.error(error);
        })
      } catch(error) {
        this.error(null, window.wishlistStrings.errors.loading);
        if (error) console.error(error);
      }
    } else {
      window.wishlist = {
        products: JSON.parse(localStorage.getItem('wishlist')) ? JSON.parse(localStorage.getItem('wishlist')) : []
      }
      this.wishlistLoaded();
    }
  }

  wishlistLoaded() {
    document.dispatchEvent(new Event('wishlist:loaded'));
  }

  static productInWishlist(id) {
    if (!window.wishlist.products) {
      return false;
    }

    return window.wishlist.products.some(product => product.id === id);
  }

  saveLocalStorageWishlist() {
    const localStorageWishlist = JSON.parse(localStorage.getItem('wishlist'));

    localStorageWishlist.forEach((product) => {
      if (!Wishlist.productInWishlist(product.id)) {
        window.wishlist.products.push(product);
      }
    });

    try {
      this.writeWishlist(wishlist)
      .then(() => {
        wishlist.products.forEach((product) => {
          const element = document.querySelector(`[data-wishlist-product-id="${product.id}"]`);
          this.klaviyoTracking(element, 'Added to wishlist');
        })

        localStorage.removeItem('wishlist');
        this.getWishlistProducts();
      })
      .catch((error) => {
        this.error(null, window.wishlistStrings.errors.saving);
        if (error) console.error(error);
      })
    } catch(error) {
      this.error(null, window.wishlistStrings.errors.saving);
      if (error) console.error(error);
    }
  }
}

class WishlistButton extends (HTMLElement) {
  constructor() {
    super();

    this.settings = {
      element: this,
      id: this.getAttribute('data-wishlist-product-id'),
      handle: this.getAttribute('data-wishlist-product-handle'),
      title: this.getAttribute('data-wishlist-product-title'),
    }

    this.init();
  }

  init() {
    this.addEventListener('click', this.onClickHandler);

    if (window.wishlist.products) {
      this.findWishlistProduct(this.settings);
    } else {
      document.addEventListener('wishlist:loaded', () => {
        this.findWishlistProduct(this.settings);
      });
    }
  }

  onClickHandler() {
    if (this.getAttribute('data-wishlist-added') === 'true') {
      document.dispatchEvent(new CustomEvent('wishlist:remove', {
        detail: this.settings
      }));

    } else {
      document.dispatchEvent(new CustomEvent('wishlist:add', {
        detail: this.settings
      }));
    }
  }

  findWishlistProduct({id, element}) {
    Wishlist.setElementRemovedState(element);

    if (Wishlist.productInWishlist(id)) {
      Wishlist.setElementAddedState(element);
    }

    Wishlist.setElementLoadingDoneState(element);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClickHandler);
  }
}

class WishlistProducts extends (HTMLElement) {
  constructor() {
    super();
    this.productsGrid = this.querySelector('.js-wishlist-products-grid');

    document.addEventListener('wishlist:loaded', () => {
      this.renderWishlistProducts();
    });
  }

  renderWishlistProducts() {
    this.classList.add('loading');
    this.classList.remove('empty');

    if (window.wishlist.products.length === 0) {
      this.classList.remove('loading');
      this.classList.add('empty');
      this.productsGrid.innerHTML = '';
      return;
    };

    const requests = [];

    window.wishlist.products.forEach((product) => {
      requests.push(fetch(`/products/${product.handle}?section_id=wishlist-product-card`));
    });

    try {
      Promise.all(
        requests
      ).then((responses) => {
        return Promise.all(responses.map((response) => {
          return response.text();
        }));
      }).then((products) => {
        this.productsGrid.innerHTML = '';
        this.classList.remove('loading');

        products.forEach((product) => {
          const parser = new DOMParser();
          const productHtml = parser.parseFromString(product, "text/html");
          const wishlistProductCard = productHtml.querySelector('.js-wishlist-product-card');

          if (this.productsGrid && wishlistProductCard) {
            this.productsGrid.innerHTML += `<li class="grid__item">${wishlistProductCard.innerHTML}</li>`
          }
        });
      }).catch((error) => {
        this.classList.remove('loading');
        this.error(null, window.wishlistStrings.errors.loading);
        if (error) console.error(error);
      });
    } catch (error) {
      this.classList.remove('loading');
      this.error(null, window.wishlistStrings.errors.loading);
      if (error) console.error(error);
    }
  }
}

customElements.define('wishlist-button', WishlistButton);
customElements.define('wishlist-products', WishlistProducts);
new Wishlist();
